export const IDLE_AFTER_MS = 30000;
export const TYPE_PAUSE_MS = 5000;
export const CHECKPOINT_MS = 300000;
export const MIN_SESSION_MS = 1000;
export const RETAB_COALESCE_MS = 5000;

const IDLE = "idle";
const VIEW = "view";
const TYPE = "type";

export function initialState(tab) {
  return { activity: IDLE, tab, start: 0, lastAt: 0, words: 0 };
}

function open(activity, tab, at) {
  return { activity, tab, start: at, lastAt: at, words: 0 };
}

function close(state, endAt) {
  if (state.activity === IDLE) return [];
  const durationMs = endAt - state.start;
  if (durationMs < MIN_SESSION_MS) return [];
  return [{ activity: state.activity, tab: state.tab, startMs: state.start, durationMs, wordCount: state.words }];
}

function idleAt(state) {
  return { ...initialState(state.tab) };
}

export function step(state, event) {
  const at = event.at;
  switch (event.type) {
    case "intent":
      if (state.activity === IDLE) return { state: open(VIEW, state.tab, at), closed: [] };
      if (state.activity === VIEW) return { state: { ...state, lastAt: at }, closed: [] };
      return { state, closed: [] };

    case "tab":
      if (state.activity === IDLE) return { state: open(VIEW, event.tab, at), closed: [] };
      if (state.activity === VIEW && at - state.start < RETAB_COALESCE_MS) {
        return { state: { ...state, tab: event.tab, lastAt: at }, closed: [] };
      }
      return {
        state: open(VIEW, event.tab, at),
        closed: close(state, state.activity === TYPE ? state.lastAt : at),
      };

    case "key":
      if (state.activity === TYPE) return { state: { ...state, lastAt: at }, closed: [] };
      return { state: open(TYPE, state.tab, at), closed: close(state, at) };

    case "send":
      if (state.activity !== TYPE) return { state, closed: [] };
      return { state: { ...state, words: state.words + Math.max(0, Number(event.words) || 0) }, closed: [] };

    case "tick": {
      if (state.activity === TYPE && at - state.lastAt >= TYPE_PAUSE_MS) {
        return { state: idleAt(state), closed: close(state, state.lastAt) };
      }
      if (state.activity === VIEW && at - state.lastAt >= IDLE_AFTER_MS) {
        return { state: idleAt(state), closed: close(state, state.lastAt) };
      }
      if (state.activity !== IDLE && at - state.start >= CHECKPOINT_MS) {
        return { state: open(state.activity, state.tab, at), closed: close(state, at) };
      }
      return { state, closed: [] };
    }

    case "hidden":
    case "leave":
      return { state: idleAt(state), closed: close(state, Math.min(at, state.lastAt + IDLE_AFTER_MS)) };

    default:
      throw new Error(`auditPresenceMachine: unknown event type "${event.type}"`);
  }
}

export function countWords(story) {
  if (!Array.isArray(story)) return 0;
  return story
    .filter((segment) => segment && segment.type === "rich_text")
    .map((segment) => String(segment.rich_text?.body_text ?? ""))
    .join(" ")
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;
}

export function countTextWords(text) {
  return String(text ?? "").trim().split(/\s+/).filter(Boolean).length;
}

export function projectTabFromPath(pathname) {
  const match = /^\/projects2?\/(\d+)(?:\/([^/]+))?\/?$/.exec(String(pathname ?? ""));
  if (!match) return null;
  return { projectId: Number(match[1]), tab: match[2] || "chat" };
}

export function toRecordParams(session, projectId) {
  return {
    project: { id: Number(projectId) },
    activity: session.activity,
    tab: session.tab,
    ref: "",
    startTime: Math.floor(session.startMs / 1000),
    durationMs: session.durationMs,
    wordCount: session.wordCount,
  };
}
